import React from 'react'
import './styles.scss'
import IconFont from '../IconFont'

interface EmptyProps {
  description?: string | React.ReactNode
}

const Empty: React.FC<EmptyProps> = (props) => {
  const { description } = props
  return (
    <div className="empty">
      <IconFont style={{ marginBottom: 10 }} name="empty" size={30} />
      <div className="description text-gray text-sm">
        {description || '暂无数据'}
      </div>
    </div>
  )
}

export default Empty
